import { useDispatch, useSelector } from "react-redux";
import React, { memo, useCallback, useEffect, useMemo, useState } from "react";
import moment from "moment";
import { getReportJwt } from "../../actions/reportJwt";
import ResponsiveIframe from "../../components/IFrame";
import FullPageError from "../../components/FullPageError";
import { useIsUrlValid } from "../../hooks/useIsUrlValid";

function WalletReportPage() {
  const dispatch = useDispatch();

  const walletConfig = useSelector((state) => state.walletConfig);
  const { config } = walletConfig || {};
  const { walletReportUrl, walletClientId } = config || {};

  const isIframeUrlValid = useIsUrlValid(walletReportUrl);
  const isConfigInvalidError = useMemo(() => {
    return !(
      walletConfig &&
      walletReportUrl &&
      walletClientId &&
      isIframeUrlValid
    );
  }, [walletConfig, walletReportUrl, walletClientId, isIframeUrlValid]);

  const reportJwt = useSelector((state) => state.reportJwt) || {};
  const { jwt, error, secretExpiresAt } = reportJwt;

  const activeDivisionId = useSelector(
    (state) => state.storage?.activeDivisionId
  );

  const [paramsStr, setParamsStr] = useState(null);

  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const fetchJwt = useCallback(() => {
    if (isConfigInvalidError) {
      return;
    }
    dispatch(getReportJwt({ tz, walletClientId }));
  }, [dispatch, tz, walletClientId, isConfigInvalidError]);
  useEffect(() => {
    if (!activeDivisionId) {
      return;
    }
    fetchJwt();
  }, [dispatch, fetchJwt, activeDivisionId]);
  // Below won't check for secret expiry on tab change within iframe
  // this is agreed for now to avoid performance downgrade with counter implementation for expiry check
  // iframe displays the message referring to browser refresh in case of issues
  // if users will raise concerns, this can be re-visited
  useEffect(() => {
    if (!jwt) {
      fetchJwt();
      return;
    }
    const expiresAtMoment = moment(secretExpiresAt);
    const isExpired = expiresAtMoment.isSameOrBefore(moment());
    if (isExpired) {
      fetchJwt();
    }
  }, [dispatch, jwt, fetchJwt, secretExpiresAt]);

  useEffect(() => {
    if (!jwt) return;
    const paramsObj = {};

    for (let i = 1; i <= 8; i++) {
      paramsObj[`p${i}.JWT_PARAM`] = jwt;
    }

    setParamsStr(encodeURIComponent(JSON.stringify(paramsObj)));
  }, [jwt]);
  const mainErrorVerbiage =
    "Configuration for Wallet Report is missing or incorrect";
  const supportErrorVerbiage = "Please ";

  return (
    <>
      {isConfigInvalidError ? (
        <FullPageError
          mainErrorVerbiage={mainErrorVerbiage}
          supportErrorVerbiage={supportErrorVerbiage}
        />
      ) : (
        <ResponsiveIframe
          src={walletReportUrl}
          minWidth={"800px"}
          srcParamsError={Boolean(error)}
          srcParams={paramsStr}
          srcParamsRequired
          showhideOverlay
          iframeLoadTimeout={16000}
        />
      )}
    </>
  );
}
export default memo(WalletReportPage);
